module.exports = __webpack_public_path__ + "static/media/main.9ba568f5.jpg";